import { createAction, props } from '@ngrx/store';

export interface ProcessStepData {
  processStep: string;
  processType: string;
  accountType?: string;
}

export interface CallToActionData {
  location: string;
  ctaName: string;
  ctaType: string;
}

export interface ProcessAbandonData {
  processStep: string;
  processType: string;
  processAbandonmentType: string;
}

export interface ProcessCompleteData {
  processType: string;
  transactionId?: string;
  accountType?: string;
  amountTransacted?: string;
  isOrgTransfer?: boolean;
}

export interface ProcessSideStepData {
  processStep?: string;
  processType: string;
  processSideStep: string;
}

export interface ProcessStartData {
  processType: string;
  processTrackingId?: string;
  accountType?: string;
  tickerSymbol?: string;
}

export interface ProcessErrorData {
  errorCode: string;
  processStep?: string;
}

export interface FileUploadData {
  documentType: string;
}
export interface SMCCallToActionData extends CallToActionData {
  sPOID: any;
  crewSPOID: any;
  processType: string;
}

export enum AdobeActionTypes {
  TrackProcessStart = '[Adobe] Track Process Start',
  TrackProcessStep = '[Adobe] Track Process Step',
  TrackCallToAction = '[Adobe] Track Call to Action',
  TrackProcessAbandon = '[Adobe] Track Process Abandoned',
  TrackProcessSideStep = '[Adobe] Track Process Side Step',
  TrackProcessComplete = '[Adobe] Track Process Complete',
  TrackProcessError = '[Adobe] Track Process Error',
  TrackFileUpload = '[Adobe] Track File Upload',
  TrackSendDocuments = '[Adobe] Track Send Documents',
}

export const TrackProcessStart = createAction(
  AdobeActionTypes.TrackProcessStart,
  props<ProcessStartData>(),
);
export const TrackProcessStep = createAction(
  AdobeActionTypes.TrackProcessStep,
  props<ProcessStepData>(),
);
export const TrackCallToAction = createAction(
  AdobeActionTypes.TrackCallToAction,
  props<CallToActionData>(),
);
export const TrackProcessAbandon = createAction(
  AdobeActionTypes.TrackProcessAbandon,
  props<ProcessAbandonData>(),
);
export const TrackProcessSideStep = createAction(
  AdobeActionTypes.TrackProcessSideStep,
  props<ProcessSideStepData>(),
);
export const TrackProcessComplete = createAction(
  AdobeActionTypes.TrackProcessComplete,
  props<ProcessCompleteData>(),
);
export const TrackProcessError = createAction(
  AdobeActionTypes.TrackProcessError,
  props<ProcessErrorData>(),
);
export const TrackSMCCallToAction = createAction(
  AdobeActionTypes.TrackCallToAction,
  props<SMCCallToActionData>(),
);
export const TrackFileUpload = createAction(
  AdobeActionTypes.TrackFileUpload,
  props<FileUploadData>(),
);
export const TrackSendDocuments = createAction(AdobeActionTypes.TrackSendDocuments);
